module.exports = __webpack_public_path__ + "static/img/lp-6.031e5f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/lp-6.png
// module id = cwmf
// module chunks = 0